import React, { useState, useEffect } from "react";
import { Alert, Slide } from "@mui/material";

const Alerts = ({ error, type, onClose }) => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertInfo, setAlertInfo] = useState({ message: "", type: "" });

  useEffect(() => {
    if (error) {
      setAlertInfo({ message: error, type });
      setShowAlert(true);

      const timer = setTimeout(() => {
        setShowAlert(false);
        onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [error, type, onClose]);

  const handleClose = () => {
    setShowAlert(false);
    onClose();
  };

  return (
    <Slide direction="down" in={showAlert} mountOnEnter unmountOnExit>
      <Alert
        variant="filled"
        severity={alertInfo.type}
        onClose={handleClose}
        className="custom-alert"
        sx={{
          position: "fixed",
          top: 10,
          left: 0,
          right: 0,
          margin: "0 auto",
          transform: "translateX(-50%)",
          maxWidth: "30%",
          zIndex: 9999,
        }}
      >
        {alertInfo.message}
      </Alert>
    </Slide>
  );
};

export default Alerts;
